// Simplified auth store (legacy compatibility layer)
// This module now only mirrors minimal auth state when explicitly set.

const SSO_LOADED = 'SSO_LOADED'

const state = {
  session: undefined
}

const mutations = {
  [SSO_LOADED](state, data) {
    state.session = data
  }
}

const actions = {
  // Kept for call‑site compatibility; real login handled by Auth0 plugin
  login() {
    console.log('[auth] login dispatched (handled by Auth0 plugin)')
  },
  authCheck() {
    return Promise.resolve()
  },
  // Allow components to inject a session snapshot if desired
  setSession({ commit }, payload) {
    commit(SSO_LOADED, payload)
  },
  // Legacy compatibility for loginWithCredentials calls
  loginWithCredentials({ commit }, { access_token, userinfo }) {
    console.log('[auth] loginWithCredentials called with:', { userinfo })
    commit(SSO_LOADED, {
      isAuthenticated: true,
      user: userinfo,
      access_token
    })
  }
}

const getters = {
  authenticated: () => Boolean(state.session && state.session.isAuthenticated),
  fullname: () => state.session?.user?.name,
  email: () => state.session?.user?.email,
  isLoaded: () => state.session !== undefined
}

export default { namespaced: true, state, actions, mutations, getters }
